import { useQuery } from '@tanstack/react-query';
import * as _a from '@/lib/api';
import { channelNewestPost } from '@/lib/api';

export const useChannelNewestPost = (cid: string) => {
  return useQuery({
    queryKey: [`channels`, cid, `channel_posts`, 'newest'],
    queryFn: () => _a.channelNewestPost(cid),
  });
};
